const classSelect = {
  path: 'classSelect',
  component: resolve => require(['../../../pages/teacher/classselect/index'], resolve)
}
export default classSelect




// WEBPACK FOOTER //
// ./src/router/teacher/classselect/index.js